import React from 'react';
import { financialBalanceStatus } from './financialStatusHelpers';
import { formatRupiah } from './trackingHelpers';

// Lunas refers to the validated current bill, not a promise about future items.
export default function FinancialBalanceStatus({ summary, shipping, po, className = '' }) {
  const status = financialBalanceStatus(summary, shipping, po);
  return <div className={className} role="status" data-finance-state={status.state}>
    <span>{status.label}</span>
    {status.amount !== null && <span> {formatRupiah(status.amount)}</span>}
  </div>;
}
